import { useOpenTimeCapsule } from "api/ApiHooks"
import { TimelineComponent } from "./TimelineComponent"
import dayjs from "dayjs"

export const OpenTimeCapsuleTimeline = ({ timeCapsuleId }: { timeCapsuleId: string }) => {
  const { data, isLoading } = useOpenTimeCapsule(timeCapsuleId)

  if (isLoading) {
    return <p>Loading...</p>
  }

  if (!data) {
    return <p>Time capsule not found</p>
  }

  const mappedEntries = data.entries.map(
    (entry) =>
      ({
        id: entry.id,
        avatarUrl: entry.creatorAvatarUrl,
        title: entry.createdBy,
        subtitle: "wrote",
        text: entry.text || "",
        timestamp: dayjs(entry.customEntryDate || entry.createdAt).format(
          "ddd HH:mm - MMM D, YYYY"
        ),
        type: "text-box"
      }) as const
  )

  return (
    <TimelineComponent
      entries={[
        {
          id: "created",
          title: "Time capsule created",
          text: "",
          timestamp:
            dayjs(data.timeCapsule.createdAt).format("ddd HH:mm - MMM D, YYYY") || "",
          type: "simple"
        },
        ...mappedEntries,
        {
          id: "opened",
          title: "Time capsule opened",
          text: "",
          timestamp:
            dayjs(data.timeCapsule.openedAt).format("ddd HH:mm - MMM D, YYYY") || "",
          type: "simple"
        }
      ]}
    />
  )
}
